import React from 'react';

import { Box, Typography } from '@mui/material';
import { SuccessIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { getIconStyles, stepIconStyles } from './StepperCDS.styles';

const StepIconComponent = props => {
  const { active, completed, icon } = props;

  return (
    <div className="flex">
      {active || completed ? (
        <div className="flex items-center gap-4">
          <Box sx={getIconStyles(completed)}>
            <Typography variant="medium12">{icon}</Typography>
          </Box>
        </div>
      ) : (
        <Box sx={stepIconStyles}>
          <SuccessIcon size={20} />
        </Box>
      )}
    </div>
  );
};

export default StepIconComponent;

StepIconComponent.propTypes = {
  active: PropTypes.bool.isRequired,
  completed: PropTypes.bool.isRequired,
  icon: PropTypes.node.isRequired,
};
